import * as React from "react";
import styled, { css } from "../../../styled/index";
import {shadeAlternate} from "../../../styled/helpers";

export const Tag = styled("span")<{ fontSize?: number; background?: string; text?: string; }>`
  display: inline-block;
  font-size: ${({fontSize}) => fontSize || 12}px;
  font-weight: 600;
  background: ${({theme, background}) => background || shadeAlternate(0.08, theme.box.background)};
  color: ${({theme, text}) => text || theme.box.text};
  padding: 5px 5px;
  border-radius: 3px;
`;
